import { render, staticRenderFns } from "./Desktop.vue?vue&type=template&id=39a7d9fb&lang=html"
import script from "./Desktop.vue?vue&type=script&lang=js"
export * from "./Desktop.vue?vue&type=script&lang=js"
import style0 from "./Desktop.vue?vue&type=style&index=0&id=39a7d9fb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports